import Vue from 'vue';
import TMAlert from '@/tools/models/TMAlert';
import ApiRequest from '@/tools/ApiRequest';
import textFieldDefaultProps from '@/tools/helpers/textFieldDefaultProps';
import RequestException from '@/tools/helpers/RequestException';
import TMAuth from '@/tools/TMAuth';

export default Vue.extend({
  data: () => ({
    textFieldProps: textFieldDefaultProps,
    userData: {
      username: '',
      password: '',
    },
  }),
  methods: {
    login(): void {
      if (this.userData.username === '' || this.userData.password === '') {
        this.invalidCredentials();
      } else {
        ApiRequest.login(this.userData)
          .then((response) => {
            localStorage.setItem('nortox-api-token', response.data.token);
            this.setUser();

            this.$router.push('/');
          })
          .catch((error) => new RequestException(error, this.$store, this.$router));
      }
    },
    invalidCredentials(): void {
      this.$store.dispatch(
        'setAlert',
        new TMAlert({
          title: 'Falha no login',
          message: 'Credeciais inváidas',
          state: true,
        }),
      );
    },
    setUser(): void {
      this.$store.dispatch('getUserFromApi').then(() => {
        if (this.$store.getters.user.id === -1) {
          TMAuth.logout(this.$router);

          this.$store.dispatch(
            'setAlert',
            new TMAlert({
              title: 'Erro',
              message: 'Não foi possível recuperar seus dados. Por favor tente novamente',
              state: true,
            }),
          );
        }
      });
    },
  },
  created(): void {
    if (TMAuth.isAuthenticated()) {
      this.$router.push('/');
    }
  },
});
